import { render, staticRenderFns } from "./Connectors.vue?vue&type=template&id=22cddc30&scoped=true&"
import script from "./Connectors.vue?vue&type=script&lang=js&"
export * from "./Connectors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cddc30",
  null
  
)

export default component.exports